module.exports = __webpack_public_path__ + "UX38.png?7238a66320d675bd4a484df3800854e0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/UX38.png
// module id = 88
// module chunks = 0